import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const TextFlow: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.00004 0.999978C0.991231 1.00876 0.984031 2.81236 0.984031 5.00798V8.99997H4.99203H9.00003V7.49997V5.99997H12H15V6.78599V7.57202L11.286 11.286L7.57198 15H4.27793H0.983887L0.989959 19.002L0.996031 23.004L4.99803 23.01L9.00003 23.0161V21.516V20.016H14.2739H19.5478L18.414 21.15L17.2801 22.2841L17.994 22.998L18.7079 23.712L21.066 21.354L23.424 18.9961L21.0661 16.6381L18.7082 14.2801L17.9941 14.9939L17.28 15.7077L18.4259 16.8538L19.5718 18H14.2859H9.00003V17.2139V16.4279L12.7141 12.7139L16.4281 8.99997H19.7221H23.0162L23.0101 4.99797L23.004 0.99597L19.002 0.989898L15 0.983826V2.4839V3.98397H12H9.00003V2.48397V0.98397H5.00804C2.81242 0.98397 1.00882 0.99117 1.00004 0.999978ZM3.00003 4.99197V6.98397H4.99203H6.98403V4.99197V2.99997H4.99203H3.00003V4.99197ZM17.016 4.99197V6.98397H19.008H21V4.99197V2.99997H19.008H17.016V4.99197ZM3.00003 19.008V21H4.99203H6.98403V19.008V17.016H4.99203H3.00003V19.008Z'
        fill={fill}
      />
    </svg>
  )
}

export default TextFlow
